import { render, staticRenderFns } from "./TutorIAChat.vue?vue&type=template&id=5d317fab"
import script from "./TutorIAChat.vue?vue&type=script&lang=js"
export * from "./TutorIAChat.vue?vue&type=script&lang=js"
import style0 from "./TutorIAChat.vue?vue&type=style&index=0&id=5d317fab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports